// src/App.js - UPDATED & MERGED
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from './firebase';

// Import the new and updated components
import Layout from './Layout';
import Login from './Login';
import FleetDashboard from './FleetDashboard';
import TabletDetail from './TabletDetail';
import Applications from './Applications';
import './index.css';
import Inquiries from './Inquiries';
import SurveyInsights from './SurveyInsights'; // ✅ IMPORT THE NEW COMPONENT
import TabletContent from './TabletContent'; // ✅ IMPORT THE NEW COMPONENT
import Drivers from './Drivers'; // ✅ IMPORT THE NEW COMPONENT
import DriverCentral from './DriverCentral'; // ✅ IMPORT THE NEW COMPONENT
import PointsReview from './PointsReview'; // 1. Import the new component
import SupportTickets from './SupportTickets';
import DriverSupport from './DriverSupport'; // Add this line
import Feedback from './Feedback'; // Add this line
function App() {
  // All your existing state and Firebase logic remains the same!
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
       currentUser.getIdTokenResult(true).then(idTokenResult => {
  // VVV ADD THIS LINE VVV
  console.log("App.js Auth Claims:", idTokenResult.claims); 
  setIsAdmin(idTokenResult.claims.admin === true);
  setAuthLoading(false);
});
      } else {
        setUser(null);
        setIsAdmin(false);
        setAuthLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError("Invalid email or password. Please try again.");
      console.error(err);
    }
  };

  if (authLoading) {
    return <p className="loading-text">Initializing...</p>;
  }

  return (
    <Router>
      <Routes>
        {/* If user is not logged in, only the /login route is available */}
        {!user && (
          <>
            <Route path="/login" element={
              <Login
                handleLogin={handleLogin}
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
                error={error}
              />
            } />
            {/* Any other route redirects to /login */}
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}

        {/* If user IS logged in, render the main layout */}
        {user && (
          <Route path="/" element={<Layout />}>
            {/* Child routes are rendered inside the Layout's <Outlet> */}
            {isAdmin ? (
              <>
                <Route index element={<FleetDashboard />} />
                <Route path="applications" element={<Applications />} />
                <Route path="tablet/:tabletId" element={<TabletDetail />} />
             <Route path="inquiries" element={<Inquiries isAdmin={isAdmin} />} />
             <Route path="survey-insights" element={<SurveyInsights />} />
             <Route path="tablet-content" element={<TabletContent />} /> {/* ✅ ADD THIS ROUTE */}
             <Route path="drivers" element={<Drivers />} /> {/* ✅ ADD THIS ROUTE */}
             <Route path="driver-central" element={<DriverCentral />} /> {/* ✅ ADD THIS ROUTE */}
             <Route path="/points-review" element={<PointsReview />} />
             <Route path="/support-tickets" element={<SupportTickets />} />
             <Route path="/driver-support" element={<DriverSupport />} />
             <Route path="/feedback" element={<Feedback />} />
              </>
            ) : (
              // If user is not an admin, show an access denied message
              <Route index element={<p className="denied-text">Access Denied. You are not an admin.</p>} />
            )}
            {/* Any other authenticated route redirects to the dashboard */}
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        )}
      </Routes>
    </Router>
  );
}

export default App;
